import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import UserImage from "../../assets/user.png"
import Loader from '../../components/Loader'

const FriendRequestsSent = () => {
    const [sentRequests, setSentRequests] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(false)

    useEffect(() => {
        const getSentFriendRequests = async () => {
            try {
                setIsLoading(true)
                const response = await api.get("/community/friends/requests/sent")
                // console.log(response)
                if (response) {
                    setIsLoading(false)
                    setSentRequests(response?.data)
                }
                else {
                    toast.error("Error getting  sent friend requests")
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response?.data.message)
            }
        }
        getSentFriendRequests()
    }, [])

    const handleRefresh = () => { }

    const removeRequest = async(id)=>{

        try {
            const response = await api.delete("/community/friends/requests/sent", {params:{friend:id}});
            if (response.status === 200) {
                toast.success("Friend request removed");
                setSentRequests((sentRequests) =>
                    sentRequests.filter((friend) => friend._id !== id)
                );
            }
        } catch (error) {
            toast.error("Failed to remove sent friend request");
        }
        
    }
    return (
        <div className='users-page-container'>
            <h2 className="users-list-header">Sent Friend Requests</h2>
            <InfiniteScroll
                dataLength={sentRequests.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="users-container">
                    {isLoading && <Loader />}
                    {!isLoading && sentRequests.length === 0 &&
                        <p className="not-found-msg">No sent friend requests found</p>
                    }
                    {
                        sentRequests && sentRequests.map((frd) => (
                            <div className='user-action-card' key={frd._id}>
                                <div className="user-action-card-details">
                                    <img src={frd.profilePics?.current ? frd.profilePics.current : UserImage} alt="" />
                                    <div className="action-card-buttons">
                                        <p className="user-names">{frd.firstname} {frd.lastname}</p>
                                        <button onClick={()=>removeRequest(frd._id)}>Remove</button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                {
                    isLoading && <Loader />
                }
                 {!isLoading && sentRequests.length === 0 && <p>No sent friend requests </p>}
            </InfiniteScroll>
        </div>
    )
}

export default FriendRequestsSent